/**
 * Product image hover zoom
 * Renders a magnified overlay on the main gallery images on PDP hover.
 * Only activates on devices with a fine pointer (mouse / trackpad).
 */
(function () {
  "use strict";

  // 2.5× magnification; pan range = (1 - 1/scale) × 100 = 60%
  const ZOOM_SCALE = 2.5;
  const PAN_RANGE = (1 - 1 / ZOOM_SCALE) * 100;

  /**
   * Grab the highest-resolution URL available from the img's srcset,
   * falling back to the src attribute.
   */
  function getHighResSrc(img) {
    const srcset =
      img.getAttribute("srcset") || img.getAttribute("data-srcset");
    if (srcset) {
      const entries = srcset
        .split(",")
        .map((s) => s.trim().split(/\s+/))
        .filter((e) => e.length >= 2 && e[1]);
      if (entries.length) {
        entries.sort((a, b) => parseInt(b[1]) - parseInt(a[1]));
        return entries[0][0];
      }
    }
    return img.src;
  }

  function setupZoom(mediaItem) {
    // Idempotent — skip if already initialised
    if (mediaItem.dataset.zoomReady) return;

    // Skip video / 3-D model slides
    if (mediaItem.querySelector("deferred-media, product-model")) return;

    const img = mediaItem.querySelector(".product__media img");
    if (!img) return;

    mediaItem.dataset.zoomReady = "1";

    // Build overlay + zoom image
    const overlay = document.createElement("div");
    overlay.className = "product__zoom-overlay";
    overlay.setAttribute("aria-hidden", "true");

    const zoomImg = document.createElement("img");
    zoomImg.className = "product__zoom-img";
    zoomImg.alt = "";
    zoomImg.draggable = false;
    overlay.appendChild(zoomImg);

    mediaItem.appendChild(overlay);

    let imgLoaded = false;

    function ensureLoaded() {
      if (imgLoaded) return;
      zoomImg.src = getHighResSrc(img);
      imgLoaded = true;
    }

    function onEnter() {
      ensureLoaded();
      overlay.classList.add("is-visible");
    }

    function onMove(e) {
      const rect = mediaItem.getBoundingClientRect();
      const x = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      const y = Math.max(0, Math.min(1, (e.clientY - rect.top) / rect.height));
      zoomImg.style.transform = `translate(${-x * PAN_RANGE}%, ${-y * PAN_RANGE}%)`;
    }

    function onLeave() {
      overlay.classList.remove("is-visible");
    }

    mediaItem.addEventListener("mouseenter", onEnter);
    mediaItem.addEventListener("mousemove", onMove);
    mediaItem.addEventListener("mouseleave", onLeave);
  }

  function init() {
    // Fine-pointer check — no-op on touch-only devices
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches)
      return;

    const gallery = document.querySelector(".product__media-list");
    if (!gallery) return;
    gallery.querySelectorAll(".product__media-item").forEach(setupZoom);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-run when Swiper adds/removes slides (lazy variant swaps)
  document.addEventListener("DOMContentLoaded", () => {
    const gallery = document.querySelector(".product__media-list");
    if (!gallery) return;
    new MutationObserver(init).observe(gallery, {
      childList: true,
      subtree: false,
    });
  });
})();
